module.exports = __webpack_public_path__ + "img/thumbnail_SomaliWildAss_f_normal.2558598e.png";